<template>
  <div>
    <h3 class="mb-0">
      Nuevo turno
    </h3>
    <hr class="w-100 my-2" />
      <base-input
        :value="name"
        @input="name = $event.toUpperCase()"
        label="Nombre del turno *"
        placeholder="Nombre del turno"
        labelClasses="text-xs"
        inputClasses="input-group-alternative form-control-sm text-xs uppercase"
        class="mb-3"
      />

      <div class="mb-3">
        <label class="form-control-label text-xs">Hora de entrada *</label>
        <flat-picker
          v-model="start"
          :config="{ 
            dateFormat: 'H:i',
            enableTime: true,  
            time_24hr: true, 
            noCalendar: true, 
            minuteIncrement: 10 
          }"
          style="cursor: pointer"
          class="input-group-alternative form-control-sm text-xs datepicker w-100"
          placeholder="Hora de entrada"
        />
      </div>

        <div class="mb-3">
          <label class="form-control-label text-xs">Hora de salida *</label>
          <flat-picker
            v-model="end"
            :config="{ 
              dateFormat: 'H:i',
              enableTime: true,  
              time_24hr: true, 
              noCalendar: true, 
              minuteIncrement: 10
            }"
            style="cursor: pointer"
            class="input-group-alternative form-control-sm text-xs datepicker w-100"
            placeholder="Hora de salida"
          />
        </div>

      <base-input
        v-model="break_lunch"
        label="Número de descansos *"
        placeholder="Número de descansos (0-2)"
        type="number"
        labelClasses="text-xs"
        inputClasses="input-group-alternative form-control-sm text-xs"
        min="0"
        max="2"
      />

    <hr class="w-100 my-3" />
    <div class="d-flex justify-content-end">
      <base-button type="white" @click="$emit('close')" size="sm">
        Cancelar
      </base-button>
      <div v-b-popover.hover.focus.bottom.html="popoverData" tabindex="0">
        <base-button 
          type="success" 
          @click="createWorkShift()" 
          icon="fa fa-check" 
          size="sm" 
          :disabled="!validation.valid || creating"
        >
          Crear
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import { setDoc, getFirestore, doc, getDoc } from "firebase/firestore";
export default {
  name: "NewWorkShift",
  components: {
    flatPicker,
  },
  data() {
    return {
      name: null,
      start: null,
      end: null,
      break_lunch: null,
      creating: false,
    };
  },
  created(){
    this.start = '00:00';
    this.end = '00:00';
  },
  methods: {
    createWorkShift() {
      if (this.validation.valid) {
        this.creating = true;
        const db = getFirestore();
        const docRef = doc(db, "work_shifts", this.name);
        getDoc(docRef).then((docSnap) => {
          if (!docSnap.exists()) {
            const json = {
              name: this.name,
              start: this.start,
              end: this.end,
              break_lunch: parseInt(this.break_lunch),
            };
            console.log("JSON", json);

            setDoc(docRef, json)
            .then(() => {
              this.$swal(this.name, "Turno registrado correctamente", "success");
              this.$emit("close");
              this.$emit("success");
            })
            .catch((e) => {
              this.$swal("Error", e.message, "error");
            })
            .finally(() => {
              this.creating = false;
            });

          } else {
            this.$swal(this.name, "El turno ya existe", "error");
          }
        });
      }
    }
  },
  computed: {
    validation() {
      const { name, start, end, break_lunch } = this;
      const complete = {
        "Nombre del turno": name,
        "Hora de entrada": start,
        "Hora de salida": end,
        "Número de descansos (0-2)": break_lunch && break_lunch >= 0 && break_lunch <= 2
      };
      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    popoverData() {
      if (!this.validation.missing.length) return null;
      return {
        title: "<small><b>Falta completar los campos:</b></small>",
        content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
